import React from 'react'
import InputFieldUI from './InputFieldUI'
import './InputText.css'

const InputTextUI = ({context, type, name, value, onChange,
    // label
    label, help, messageList, labelKey, helpKey,
    // behavior
    required, maxLength, autoFocus, disabled, error}) =>
  <InputFieldUI className='w_input_txt' name={name} required={required}
    label={label} help={help} messageList={messageList} labelKey={labelKey} helpKey={helpKey}>
    <input type={type === 'password' ? 'password' : 'text'} name={name} value={value} onChange={onChange}
      maxLength={maxLength ? maxLength : ''} autoFocus={autoFocus} disabled={disabled}
      className={`${error ? 'hasError' : ''} ${disabled ? 'disabled' : ''}`.trim()}
    />
  </InputFieldUI>

export default InputTextUI
